<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="客户名称" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.customerName" placeholder="请输入客户名称"></el-input>
					</el-form-item>
					<el-form-item label="客户编码" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.code" placeholder="请输入客户编码"></el-input>
					</el-form-item>
                    <el-form-item label="状态" class='tiny'>
						<el-select v-model="searchInfo.status" class="big" placeholder="请选择状态" clear>
							<el-option :key="0" label="停用" :value="0"></el-option>
							<el-option :key="1" label="正常" :value="1"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="时间">
						<div class="block">
							<el-date-picker v-model="timerArr" value-format="yyyy-MM-dd HH:mm:ss"
								type="datetimerange" start-placeholder="开始日期" end-placeholder="结束日期"
								:default-time="['00:00:00', '23:59:59']">
							</el-date-picker>
						</div>
					</el-form-item>
                    <!-- customerClassId -->

					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button @click="empty">清空</el-button>
							
							
							<el-button type="primary" @click="downloadFile"> 导出 </el-button>

							<el-button type="primary" @click="adduser"> 新增 </el-button>
						</template>
					</el-form-item>
				</el-form>
			</header>
		</div>
		<el-table :data="userList.list" stripe style="width: 100%;" :header-cell-style="headClass" v-loading="loading"
			element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
			
			<el-table-column prop="id" label="ID" sortable align="center" width="90">
			</el-table-column>
			<el-table-column prop="customerLogo" label="LOGO" align="center" :formatter="changeNull">
				<template slot-scope="scope">
					<img :src="scope.row.customerLogo" style="width: 50px;height: 50px;border-radius: 50%;" />
				</template>
			</el-table-column>
			<el-table-column prop="customerName" label="名称" align="center" :formatter="changeNull">
			</el-table-column>
			
            <el-table-column prop="code" label="客户编码"  align="center" :formatter="changeNull" :show-overflow-tooltip="true">
			</el-table-column>
            <el-table-column prop="customerIntro" label="客户介绍"  align="center" >
                <template slot-scope="scope">
                    　<el-button size="small" type="text" @click="introduce(scope.row.customerIntro)">
						查看</el-button>
                </template>
			</el-table-column>
            <el-table-column prop="customerClassId" label="主营产品"  align="center" :formatter="changeProduct" :show-overflow-tooltip="true">
			</el-table-column>
             <el-table-column prop="businessHours" label="经营时间"  align="center" :formatter="changeNull">
			</el-table-column>
            <el-table-column prop="status" label="状态" align="center" width="80">
				<template slot-scope="scope">
					<p v-if="scope.row.status" style="color: green;">正常</p>
					<p v-else style="color: red;">停用</p>
				</template>
			</el-table-column>
			<el-table-column label="详细地址" align="center" :show-overflow-tooltip="true">
                <template slot-scope="scope">
					<!-- <span>{{scope.row.province}}{{scope.row.city}}{{scope.row.area}}{{scope.row.address}}</span> -->
					<span>{{scope.row.address}}</span>
				</template>
			</el-table-column>
			<el-table-column prop="createTime" label="注册时间" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="updateTime" label="更新时间" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column fixed="right" label="操作" align="center" width="160px">
				　　　　<template slot-scope="scope">
					　　　　　　<el-button size="small" type="text" @click="dialogVisibleFun(scope.row.id)">
						编辑</el-button>
						<el-button size="small" type="text" @click="toDelete(scope.row.id)">
							删除</el-button>
						<el-button size="small" type="text" @click="connlook(scope.row.id)">
							联系人</el-button>	
				</template>
				
			</el-table-column>
		</el-table>
		<el-pagination style="margin: 20px 0px 20px 0px ;" background :current-page="userList.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="userList.total"
			@size-change="handleSizeChange">
		</el-pagination>
		
		
		
		<!-- 新增 -->
		<el-dialog style="float:rigin" :title="dialogVisibleFunName" :closeOnClickModal="false"
			:visible.sync="dialogVisibleuser" width="1000px">
			<div class="app-container" style="text-align: center;padding-right:80px">
				<el-form size="medium">
					<div style="display: flex;align-items: center;">
						<el-form-item label="客户名称" label-width="120px">
							<el-input type="text" clearable v-model="userInfo.customerName" placeholder="请输入客户名称" 
							 style="width: 250px;"/>
						</el-form-item>
						<el-form-item label="客户编码" label-width="120px" >
							<el-input type="text" clearable v-model="userInfo.code" placeholder="请输入客户编码" 
							style="width: 250px;"/>
						</el-form-item>
						<el-form-item label="状态" style="display: flex;align-items: center;margin-left:20px;
						justify-content: flex-start;">
							<el-switch v-model="userInfoStatus" :active-value="1" :inactive-value="0">
							</el-switch>
						</el-form-item>
                        
					</div>
					<div style="display: flex;">
						<el-form-item label-width="120px"  label="主营产品">
							<el-select filterable v-model="userInfo.customerClassId" style="width:250px" placeholder="请选择" clear
                            multiple >
								<el-option v-for="it in froductListShow" :key="it.id" 
                                :value="it.id+''" :label="it.className"></el-option>
							</el-select>
						</el-form-item>
                        <el-form-item  label="经营时间"  label-width="120px">
							<el-time-picker
								is-range
								v-model="userInfo.businessHours"
								value-format="HH:mm"
								format="HH:mm"
								range-separator="至"
								start-placeholder="开始时间"
								end-placeholder="结束时间"
								placeholder="选择时间范围" style="width:250px">
							</el-time-picker>
						</el-form-item>
					</div>
                    <!-- <div>
                        <el-form-item label="状态" label-width="120px">
							 <el-select v-model="userInfo.status" class="big" placeholder="请选择状态" clear>
							 	<el-option :key="0" label="停用" :value="0"></el-option>
							 	<el-option :key="1" label="正常" :value="1"></el-option>
							 </el-select>			
						</el-form-item>
                        
                    </div> -->
                    <div style="display: flex;align-items: center;justify-content: space-between;">
                        <el-form-item label="所属区域:" label-width="120px">
                            <el-select clearable filterable v-model="userInfo.provinceId" placeholder="请选择省"
                                @change="provinceFocus">
                                <el-option v-for="item in provinceList" :key="item.id" :label="item.name" :value="item.id">
                                </el-option>
                            </el-select>
                            <el-select clearable filterable v-model="userInfo.cityId" placeholder="请选择市"
                                @change="cityFcus">
                                <el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.id">
                                </el-option>
                            </el-select>
                            <el-select clearable filterable v-model="userInfo.areaId" placeholder="请选择区"
                                @change="districtFcus">
                                <el-option v-for="item in districtList" :key="item.id" :label="item.name" :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
					</div>
                    <div>
                        <el-form-item label="详细地址" label-width="120px">
							<el-input type="text" v-model="userInfo.address" placeholder="请输入详细地址" />
							<el-button icon="el-icon-position" @click="openMap()" type="primary"></el-button>
						</el-form-item>
                    </div>
					<div style="display: flex;align-items: center;">
                        <!-- <el-form-item label="头像" label-width="120px" style="width: 100%;display: flex;align-items: initial;">
                            <br />
                            <el-upload :action="httpUrl" list-type="picture-card" :on-preview="handlePictureCardPreview1"
                                :on-remove="handleRemove1" :file-list="fileList1" :show-file-list="true" :limit='1'
                                :on-success="onSuccess1">
                                <i class="el-icon-plus" ></i>
                            </el-upload>
                        </el-form-item>	 -->

                        <el-form-item label="头像" label-width="120px">
                            <el-upload class="upload-demo" :action="httpUrl" :show-file-list="false"
                                :on-success="onSuccess1" :on-remove="handleRemove1" :limit="1" :file-list="fileList1">
                                <el-button size="small" type="primary">点击上传</el-button>
                            </el-upload>
                        </el-form-item>
                        <div style="width:30px"></div>
                        <el-form-item label="头像" label-width="100px">
                            <img v-if="photoImages" :src="photoImages" width="100px" hegiht="100px" />
                            <div v-else>请上传图片</div>
                        </el-form-item>
					</div>
                    <!-- <div style="text-align: start;margin: 10px;">客户介绍</div> -->
                   <div style="height: ;">
					   <el-form-item label="客户介绍" label-width="120px">
					       <div id="lpc-quill" class="quill" style="width:100%">
					           <el-upload class="upload-demo" v-show="false" ref="upload" :action="httpUrl"
					               :before-upload="beforeAvatarUpload" :on-success="upScuccess" :on-error="uploadError" />
					           <quill-editor style="height: 400px;" v-model="userInfo.customerIntro" ref="myQuillEditor" class="editer" :options="editorOption"
					               @ready="onEditorReady($event)">
					           </quill-editor>
					       </div>
					   </el-form-item>
				   </div>
					
		
				</el-form>
			</div>
			<div style="text-align: center;margin-top: 100px;">
				<el-button @click="dialogVisibleuser = false">取 消</el-button>
				<el-button v-if="dialogVisibleFunName == '新增'" type="primary" @click="add" :loading="addLoading">添 加</el-button>
				<el-button v-if="dialogVisibleFunName == '编辑'" type="primary" @click="sure" :loading="sureLoading">编 辑</el-button>
			</div>
		</el-dialog>
		
		<el-dialog :visible.sync="dialogVisibleImg" style="float:rigin;height: 100%;" :closeOnClickModal="false"
        title="详情">
            <div v-if="popupType == 1">
                <el-carousel indicator-position="outside" style="height: 600px;">
                    <el-carousel-item v-for="(item,index) in dialogImageUrl" :key="index" style="height: 500px;">
                        <img :src="item" style="width: 100%; height: 100%;" />
                    </el-carousel-item>
                </el-carousel>
            </div>
            <div v-if="popupType==2">
                <div v-html="dialogHtml"></div>
            </div>
            <div style="height:30px"></div>
			<el-button type="primary" @click="dialogVisibleImg = false">关 闭</el-button>
		</el-dialog>
		<el-dialog style="float:rigin" title="联系人" :visible.sync="connDialogVisible" width="80%"
		:close-on-click-modal="false">
			<el-table :data="connData.list" stripe style="width: 100%;" :header-cell-style="headClass"
				v-loading="loadingTwo" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" 
				height="550"
				row-key="id"
				:tree-props="{ hasChildren: 'hasChildren', children: 'children' }">
				<el-table-column prop="id" label="用户ID" align="center" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="customerName" label="客户名称" align="center" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="linkUser" label="联系人名称"  align="center" :show-overflow-tooltip="true"></el-table-column>
				
				<el-table-column prop="phone" label="电话" align="center" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="identity" label="身份介绍" align="center" :show-overflow-tooltip="true">
					
				</el-table-column>
				<el-table-column prop="wx" label="微信号" align="center" :show-overflow-tooltip="true">
					
				</el-table-column>
				<el-table-column prop="qq" label="QQ" align="center" :show-overflow-tooltip="true">
					
				</el-table-column>
				<el-table-column prop="email" label="邮箱" align="center" :show-overflow-tooltip="true">
					
				</el-table-column>
				<el-table-column prop="photos" label="照片"  align="center" >
				    <template slot-scope="scope">
						<span v-if="!scope.row.photos">暂无</span>
				        <el-button v-else size="small" type="text" @click="introduce1(scope.row.photos)">
							查看</el-button>
				    </template>
				</el-table-column>
				<el-table-column label="地址" align="center" :show-overflow-tooltip="true">
				    <template slot-scope="scope">
						<span>{{scope.row.province}}{{scope.row.city}}{{scope.row.area}}{{scope.row.address}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="createTime" label="添加时间" align="center" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="updateTime" label="更新时间" align="center" :show-overflow-tooltip="true">
				</el-table-column>
				
				
			</el-table>
		
			<el-pagination background :current-page="connData.pageNum"
				@current-change="pageWgChange" layout="total, sizes, prev, pager,next" :total="connData.total"
				@size-change="handleWgSizeChange">
			</el-pagination>
			<span slot="footer" class="dialog-footer">
				<el-button @click="connDialogVisible = false">返回</el-button>
			</span>
		</el-dialog>
		<MapSelect ref="ms" @on-select="selectAddress" />	
	</div>
</template>

<script>
	import {
		uploadFile
	} from "@/api/axios.js";
    var urls = uploadFile();
    
    import {
		quillEditor
	} from "vue-quill-editor"; //调用编辑器
	import "quill/dist/quill.core.css";
	import "quill/dist/quill.snow.css";
	import "quill/dist/quill.bubble.css";

	import MapSelect from '@/components/MapSelect'
	Array.prototype.remove = function(val) {
		var index = this.indexOf(val);
		if (index > -1) {
			this.splice(index, 1);
		}
	};

	export default {
		components: {
			//使用编辑器
			quillEditor,
			MapSelect
		},  
		data() {
			return {
				userInfo:{},
				loading: false,
				dialogVisibleImg:false,
				connDialogVisible:false,
				dialogImageUrl:[],
				connData:[],
				remark:'',
				fileList: [],
				fileList1: [],
				userList: [{}], //用户列表
				propertyDialogVisible: false,
				httpUrl: urls,
				inviteDialogVisible: false,
				dialogVisible: false,
				editDialogVisible: false,
				dialogVisibleFunName:'',
				editUserDialogVisible: false, // 编辑用户弹窗
				editAgentDialogVisible: false, // 设置代理弹窗
				formLabelWidth: "200px",
				form: {
					username: "",
					password: "",
					surePass: "",
					userLevel: "",
					userLevel: "",
					vipLevel: "",
				},
				goodsImages: [],
				photoImages:'',
				page: {
					pageNum: 1,
					pageSize: 10,
					connpageNum: 1,
					connpageSize: 10,
				},
                searchInfo: {},
                loadingTwo: false,
				//新增弹窗
				dialogVisibleuser:false,
				setTLevelData: {
					agentLevel: "",
					provinceId: "",
					cityId: "",
					areaId: "",
					status: false,
					userId: "",
					id: "",
					data: [{
							name: ""
						},
						{
							name: ""
						},
						{
							name: ""
						}
					]
                },
                editorOption: {
					// 富文本编辑器配置
					placeholder: "请输入内容",
					modules: {
						toolbar: {
							container: [
								["bold", "italic", "underline", "strike"], // 加粗，斜体，下划线，删除线
								[{
									header: 1,
								},
								{
									header: 2,
								},
								], // 标题，键值对的形式；1、2表示字体大小
								[{
									list: "ordered",
								},
								{
									list: "bullet",
								},
								], // 列表
								[{
									script: "sub",
								},
								{
									script: "super",
								},
								], // 上下标
								[{
									indent: "-1",
								},
								{
									indent: "+1",
								},
								], // 缩进
								[{
									direction: "rtl",
								},], // 文本方向
								[{
									size: ["small", false, "large", "huge"],
								},], // 字体大小
								[{
									color: [],
								},
								{
									background: [],
								},
								], // 字体颜色，字体背景颜色
								[{
									align: [],
								},], // 对齐方式
								["clean"], // 清除字体样式
								["image"], // 上传图片、上传视频
							],
							handlers: {
								image: function (value) {
									// console.log(value)
									if (value) {
										document
											.querySelector("#lpc-quill .upload-demo input")
											.click();
									} else {
										this.quill.format("image", false);
									}
								},
							},

						},
					},
					theme: "snow",
				},

				logo: "",
                
                popupType: 1, //弹窗类型
                dialogHtml:"",

                getProductList: [],
                froductListShow: [],

                provinceList: {},
				cityList: {},
                districtList: {},
                
                addLoading: false,
				sureLoading: false,
				
				timerArr:[],

				mainForm:{},
				// address:'',
				latitude:'',
				longitude:'',
				userInfoStatus: 1,
				connid:''
			};
		},
		methods: {
			pageWgChange(data) {
				// console.log(data);
				this.page.connpageNum = data
				this.connlist()
			},
			handleWgSizeChange(val) {
				this.page.WGPageSize = val
				this.connlist()
			},
			connlook(id){
				this.connid=id
				this.connDialogVisible=true
				this.connlist()
			},
			connlist(){
				let data={
					pageNum:this.page.connpageNum,
					customerId:this.connid,
					pageSize:this.page.connpageSize
				}
				this.$api.clientLinkman(this.$encrypt(data)).then(res=>{
					res.data=JSON.parse(this.$decrypt(res.data)).data
					this.connData=res.data
				})
			},
			// 打开地图弹窗
			openMap() {
				// console.log(1223)
				this.$refs.ms.show();
				// 根据省市区设置初始值
				this.$refs.ms.setLocationByAddress(this.mainForm.address);
				// 根据经纬度设置初始值
				if(this.userInfo.lat){
					this.$refs.ms.setLocationByLatLng(this.userInfo.latitude,this.userInfo.longitude);
				}else{
					// console.log(this.mainForm.lat,this.mainForm.lng);
				this.$refs.ms.setLocationByLatLng(this.mainForm.lat, this.mainForm.lng);
				}
				
			},
			
			// 地址选择后的回调函数
			selectAddress(address, lat, lng) {
				// console.log('详细地址--',address);
				this.userInfo.address = address;
				this.latitude=lat
				this.longitude=lng
				
			},
            upScuccess(res, file) {
				const quill = this.$refs.myQuillEditor.quill;
				if (res.state == "success" && res.message !== null) {
					const length = quill.getSelection().index; // 获取光标所在位置
					quill.insertEmbed(length, "image", res.message); // 插入图片
					quill.setSelection(length + 1); // 调整光标位置到最后
				} else {
					this.$message.error("图片上传失败");
				}
            },
            uploadError() {
				this.$message.error("图片上传失败");
			},
			onEditorReady(editor) {
				// 准备编辑器
				// console.log(editor);
			},
            getSheng(){
                //查询省
                this.$api.getArea(0).then((res) => {
					if (res.state == 'success') {
						this.provinceList = res.data
					}
				})
            },
            //查询市
			provinceFocus(e) {
				let obj = {};
				obj = this.provinceList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.userInfo.province = obj.name
				this.userInfo.provinceId = e
				this.userInfo.cityId = ""
				this.cityList = {}
				this.districtList = {}
				if (e) {
					this.$api.getArea(e).then((res) => {
						if (res.state == 'success') {
							this.cityList = res.data
						}
					})
				}
			},
			//查询区
			cityFcus(e) {
				this.userInfo.cityId = e
				let obj = {};
				obj = this.cityList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.userInfo.city = obj.name
				this.districtList = {}
				if (e) {
					this.$api.getArea(e).then((res) => {
						if (res.state == 'success') {
							this.districtList = res.data
						}
					})
				}
			
            },
            districtFcus(e) {
				this.userInfo.areaId = e
				let obj = {};
				obj = this.districtList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.userInfo.area = obj.name
			},
			introduce1(e){
				this.popupType = 1;
				this.dialogImageUrl = e.split(',');
				this.dialogVisibleImg = true;
			},
            introduce(e) {
                this.popupType = 2;
                this.dialogHtml = e;
				this.dialogVisibleImg = true;
			},
            sure() { //编辑
                this.sureLoading = true
				let data = {
					address: this.userInfo.address,
                    area: this.userInfo.area,
                    areaId: this.userInfo.areaId,
                    city: this.userInfo.city,
                    cityId: this.userInfo.cityId,
                    province: this.userInfo.province,
                    provinceId: this.userInfo.provinceId,

                    status: this.userInfoStatus,
                    code: this.userInfo.code,
                    customerIntro: this.userInfo.customerIntro,
                    customerName: this.userInfo.customerName,
                    businessHours: this.userInfo.businessHours ? this.userInfo.businessHours.join("-") : '', //营业时间
                    customerClassId: this.userInfo.customerClassId.join(','),
                    customerLogo :this.photoImages,

					id: this.userInfo.id,
					
					longitude: this.longitude,
					latitude: this.latitude
				}
			
				this.$api.updateFactory(this.$encrypt(data)).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.getUserList()
					} else {
						this.$message.error(res.message);
                    }
                    
					this.sureLoading = false
					this.dialogVisibleuser = false;
				})
			},
			add(){
                this.addLoading = true;
				let data={
                    // ...this.userInfo,
                    address: this.userInfo.address,
                    area: this.userInfo.area,
                    areaId: this.userInfo.areaId,
                    city: this.userInfo.city,
                    cityId: this.userInfo.cityId,
                    province: this.userInfo.province,
                    provinceId: this.userInfo.provinceId,

                    status: this.userInfoStatus,
                    code: this.userInfo.code,
                    customerIntro: this.userInfo.customerIntro,
                    customerName: this.userInfo.customerName,
                    businessHours: this.userInfo.businessHours ? this.userInfo.businessHours.join("-") : '', //营业时间
                    customerClassId: this.userInfo.customerClassId.join(','),
					customerLogo :this.photoImages,
					
					longitude: this.longitude,
					latitude: this.latitude
                }
                // console.log('新增信息---', data)
				this.$api.addFactory(this.$encrypt(data)).then(res=>{
                    if(res.state=='success'){
                        this.$message({
                            message: res.message,
                            type: 'success'
                        });
                        this.dialogVisibleuser = false;
                        this.userInfo={}
                        this.getUserList();
                    }
                    this.addLoading = false;
				})
			},
			adduser(){
				this.userInfo={}
				this.dialogVisibleuser=true
				this.goodsImages=''
				this.fileList=[]
				this.fileList1=[]
				this.photoImages=''
				this.userInfo.status = 1;
                
                this.$api.getProductList({
                    pageNum: 1,
                    pageSize: 50,
                    isShow:true
                }).then((res) => { 
					if (res.state == 'success') {
                        // console.log('产品---', res.data.list)
                        this.froductListShow = res.data.list
					}else{

                    }
				})
                

				this.dialogVisibleFunName='新增'
			},
			// 编辑弹窗
			dialogVisibleFun(id) {
                this.$api.getProductList({
                    pageNum: 1,
                    pageSize: 50,
                    isShow:true
                }).then((res) => { 
					if (res.state == 'success') {
                        // console.log('产品---', res.data.list)
                        this.froductListShow = res.data.list
					}else{

                    }
				})
				this.photoImages=''
                this.$api.getFactoryByID(id).then(res=>{
					res.data=JSON.parse(this.$decrypt(res.data)).data
                    if(res.state == 'success'){
						// console.log('数据---', res.data)
                        this.userInfo = res.data;
						this.photoImages = res.data.customerLogo;
						this.userInfoStatus = res.data.status;
                        if(res.data.businessHours){
                            this.userInfo.businessHours = res.data.businessHours.split('-');
                        }
                        if(res.data.customerClassId){
                            this.userInfo.customerClassId = res.data.customerClassId.split(',');
                        }   
                       
                        // console.log('更具ID查询---', this.userInfo)

                        if(res.data.cityId){
                            this.$api.getArea(res.data.provinceId).then((res) => {
                                if (res.state == 'success') {
                                    this.cityList = res.data
                                }
                            })
                        }
                        if(res.data.areaId){
                            this.$api.getArea(res.data.cityId).then((res) => {
                                if (res.state == 'success') {
                                    this.districtList = res.data
                                }
                            })
                        }
						
						this.longitude=res.data.longitude
						this.latitude=res.data.latitude
                    }
                    
                })
				this.dialogVisibleuser=true
				this.dialogVisibleFunName='编辑'
			
			},
			//导出
			downloadFile() {
				let data = {
					...this.searchInfo,
					startTime: this.timerArr ? this.timerArr[0] : "",
					endTime: this.timerArr ? this.timerArr[1] : "",
				};
				// console.log(data);
				this.$api.exportExcelFactory(data).then((res) => {
					// console.log(res.data);
					this.showloadFile(res.data);
				});
			},
			showloadFile(res) {
				if (!res) {
					return;
				}
				const link = document.createElement("a");
				let blob = new Blob([res], {
					type: "application/vnd.ms-excel",
				});
				link.style.display = "none";
				link.href = URL.createObjectURL(blob);
				link.setAttribute("download", "客户管理" + ".xls");
				document.body.appendChild(link);
				link.click();
				URL.revokeObjectURL(link.href); // 释放URL 对象
				document.body.removeChild(link);
			},
            changeProduct(row, column, cellValue){ //处理主营产品
				let list = [];
				if(cellValue){
					let arr = cellValue.split(',');
					this.getProductList.forEach((item)=>{
						if( arr.indexOf(item.id+'') != -1 ){
							list.push(item.className)
						}
					})
					if(list.length > 0){
						return list.join(',')
					}else{
						return "暂无匹配";
					}
					
				}else{
					return "暂无";
				}
                
            },
			changeNull(row, column, cellValue) { //处理数据为null的情况
				if (cellValue) {
					return cellValue;
				} else {
					return "暂无";
				}
			},
			empty() {
				this.timerArr = [];
				this.searchInfo = {};
			},
			search() {
				this.page.pageNum = 1;
				this.getUserList()
			},

			onSuccess1(response, file, fileList) {
				// console.log(res)
				this.photoImages = response.message;
				// console.log("asda",response,this.goodsImages)
			},
			handleRemove1(file, fileList) {
				if (file.response) {
					this.goodsImages.remove(file.response.message);
				}
				this.goodsImages.remove(file.url);
			},
			handlePictureCardPreview1(file) {
                this.popupType = 1;
				this.dialogImageUrl = file.url.split(',');
				this.dialogVisibleImg = true;
			},
			onSuccess(response, file, fileList) {
				// console.log(res)
				this.goodsImages.push(response.message);
				// console.log("asda",response,this.goodsImages)
			},
			handleRemove(file, fileList) {
				if (file.response) {
					this.goodsImages.remove(file.response.message);
				}
				this.goodsImages.remove(file.url);
			},
			handlePictureCardPreview(file) {
                this.popupType = 1;
				this.dialogImageUrl = file.url.split(',');
				this.dialogVisibleImg = true;
			},
			//上传logo
			upLoadLogo(param) {
				const formData = new FormData()
				formData.append('file', param.file)
				this.$api.uploadFile(formData, "goods").then((res) => {
					// console.log('列表:', res);
					this.logo = res.data
				})
			},
			// 上传图片前，筛选
			beforeAvatarUpload(file) {
				const isLt2M = file.size / 1024 / 1024 < 8;
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 8MB!');
					return false;
				};
				var imgStr = /\.(jpg|jpeg|png|bmp|BMP|JPG|PNG|JPEG)$/;
				if (!imgStr.test(file.name)) {
					this.$message.error("文件不是图片类型，请上传正确格式图片！");
					return false;
				};
				return isLt2M, imgStr;
			},
	
			//删除
			toDelete(row) {
				var str = "确认删除该客户, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					
					this.$api.delFactoryByID(row).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.getUserList();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
			formartDate(row, column) {
				var ymdhis = "";
				if (row) {
					var time = new Date(row);
					ymdhis += time.getFullYear() + "-";
					ymdhis += ((time.getMonth() + 1) < 10 ? '0' + (time.getMonth() + 1) : (time
						.getMonth() + 1)) + "-";
					ymdhis += (time.getDate() < 10 ? '0' + time.getDate() : time.getDate()) + ' ';
					ymdhis += (time.getHours() < 10 ? '0' + time.getHours() : time.getHours()) + ":";
					ymdhis += (time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes()) + ":";
					ymdhis += (time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds());
					return ymdhis;
				} else {
					return '无';
				}

			},
			pageChange(data) {
				this.page.pageNum = data
				this.getUserList()
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.getUserList()
			},
			getUserList() {
				this.loading = true
				

				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					...this.searchInfo,
					startTime: this.timerArr ? this.timerArr[0] : "",
					endTime: this.timerArr ? this.timerArr[1] : "",
				}
				this.$api.factory(this.$encrypt(data)).then((res) => { 
					res.data=JSON.parse(this.$decrypt(res.data)).data
					if (res.state == 'success') {
						this.userList = res.data
						this.loading = false
					}
				})
			},

            productList(){
                let data = {
					pageNum: 1,
					pageSize: 50,
				}
                this.$api.getProductList(data).then((res) => { 
					// console.log(res);
					if (res.state == 'success') {
                        // console.log('产品---', res.data.list)
                        this.getProductList = res.data.list
					}else{
					
                    }
				})
            },
		},
		created() {
			this.getUserList();

            this.productList();
            
            this.getSheng();
		}
	};
</script>

<style>
	.demo-table-expand {
		font-size: 0;
	}

	.demo-table-expand label {
		width: 100px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}
</style>
